<template>
    <div>
        <div v-if="campaignImage && campaignImage.length > 1">
            <carousel id="detail_carousel"
                :responsive="carouselConfig.responsive"
                :lazyLoad="true"
                :nav="false"
                :rewind="false"
                :loop="true"
                :autoplay="true"
                :item="1">
                <div class="detail-img"
                    :class="imgCampaignClass"
                    v-for="(image, k) in campaignImage" :key="k">
                    <img :src="image.fullImageUrl" class="img-fluid" />
                </div>
            </carousel>
        </div>
    <div class="detail-img"
        :class="imgCampaignClass"
        v-if="campaignImage && campaignImage.length == 1">
        <img :src="campaignImage[0].fullImageUrl" class="img-fluid" />
    </div>
</div>
</template>

<script>
import Carousel from "vue-owl-carousel";

export default {
    name: "Picture",
    components: {
        Carousel
    },
    props: {
        imgClass: String,
        userType: String,
        campaignImage: Array
    },
    data: function() {
        return {
            imgCampaignClass: '',
            carouselConfig: {
                responsive: {
                0: { items: 1 }
                }
            }
        };
    },
    created: function () {
        this.imgCampaignClass = this.imgClass || 'default';
    }
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
    @import "@/style/base/common.scss";
    @import "@/style/custom/owl.scss";
    .detail-img {
        width: 100%;
        border: 1px solid rgba(229, 229, 229, 0.87);
        border-radius: 10px;

        &.default {
            @include baseCampaignImg(66.67%);
        }

        &.news {
            @include baseCampaignImg(66.67%);
        }
    }

    .farmer {
        #detail_carousel {
            @include owl(rgba(255, 255, 255, 0.5), $green-00987F);
        }
    }

    .subdist {
        #detail_carousel {
            @include owl(rgba(255, 255, 255, 0.5), $subdist);
        }
    }

    .dist {
        #detail_carousel {
            @include owl(rgba(255, 255, 255, 0.5), $dist);
        }
    }

    .sale {
        #detail_carousel {
            @include owl(rgba(255, 255, 255, 0.5), $sale);
        }
    }
</style>

